// 选片本地缓存（独立于 delivery）：把选片人姓名与已选照片缓存到 localStorage，
// 按 token 隔离，刷新或重新进入页面后选片列表与姓名都不丢失。
// 每条 pick 形状：{ id, name, path, thumbnailUrl, downloadUrl, note? }
// note 为该照片的修图指引（可选）。提交到后端时取 { path, name, note? }。
//
// 所有写操作都会返回 boolean 表示是否真正落盘成功：隐私模式 / 配额已满 /
// 部分小程序内嵌浏览器会让 localStorage.setItem 静默抛错，调用方应据此提示用户
// “未保存”，而不是假设写入总是成功。

const NAME_PREFIX = "selection-name:";
const PICKS_PREFIX = "selection-picks:";
const SUBMITTED_PREFIX = "selection-submitted:";

function nameKey(token) {
    return `${NAME_PREFIX}${token}`;
}

function picksKey(token) {
    return `${PICKS_PREFIX}${token}`;
}

function submittedKey(token) {
    return `${SUBMITTED_PREFIX}${token}`;
}

function isValidPick(entry) {
    return Boolean(
        entry &&
            typeof entry === "object" &&
            typeof entry.id === "string" &&
            entry.id &&
            typeof entry.path === "string" &&
            entry.path
    );
}

export function getSelectorName(token) {
    try {
        const raw = localStorage.getItem(nameKey(token));
        return typeof raw === "string" ? raw : "";
    } catch {
        return "";
    }
}

// 返回 true 表示已成功写入 localStorage；返回 false 时调用方应提示用户保存失败。
export function setSelectorName(token, name) {
    try {
        const trimmed = (name || "").trim();
        if (trimmed) {
            localStorage.setItem(nameKey(token), trimmed);
        } else {
            localStorage.removeItem(nameKey(token));
        }
        return true;
    } catch {
        return false;
    }
}

export function getPicks(token) {
    try {
        const raw = localStorage.getItem(picksKey(token));
        if (!raw) {
            return [];
        }
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [];
        }
        // 过滤掉结构损坏的条目（如被截断的 JSON、被其他脚本污染的数据），
        // 避免把 undefined/字符串等垃圾数据当成正常选片渲染出去。
        return parsed.filter(isValidPick);
    } catch {
        return [];
    }
}

// 返回 true 表示已成功写入 localStorage；返回 false 时调用方应提示用户本次修改未保存。
export function savePicks(token, picks) {
    try {
        const list = Array.isArray(picks) ? picks.filter(isValidPick) : [];
        localStorage.setItem(picksKey(token), JSON.stringify(list));
        return true;
    } catch {
        return false;
    }
}

export function clearPicks(token) {
    try {
        localStorage.removeItem(picksKey(token));
        return true;
    } catch {
        return false;
    }
}

// 记录某 token 已成功提交（用于提示客户），保存提交摘要。
export function getSubmittedInfo(token) {
    try {
        const raw = localStorage.getItem(submittedKey(token));
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
    } catch {
        return null;
    }
}

// 返回 true 表示已成功写入 localStorage；返回 false 时调用方应提示用户提交状态未能保存到本机。
export function setSubmittedInfo(token, info) {
    try {
        localStorage.setItem(submittedKey(token), JSON.stringify(info || {}));
        return true;
    } catch {
        return false;
    }
}

export function clearSubmittedInfo(token) {
    try {
        localStorage.removeItem(submittedKey(token));
        return true;
    } catch {
        return false;
    }
}
